// grid-nav

if (!customElements.get('grid-nav')) {
  class GridNav extends HTMLElement {
    abortController = null

    constructor() {
      super()
    }

    async connectedCallback() {
      this.content = this.querySelector('.js-grid-nav-content')
      this.sectionId = this.getAttribute('data-section-id')
      await this.fetchMenu()
      setTimeout(() => {
        this.listenForUrlParam()
      }, 100)
      this.addEventListener('change', this.tabChangeHandle.bind(this))
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.tabChangeHandle.bind(this))
    }

    listenForUrlParam() {
      const urlParams = new URLSearchParams(window.location.search)
      const dep = urlParams.get('dep')
      if (dep) {
        const inputValue =
          dep === 'boys'
            ? 'mobile-nav-boys'
            : dep === 'womens'
              ? 'mobile-nav-womens'
              : dep === 'kids'
                ? 'mobile-nav-kids'
                : dep === 'girls'
                  ? 'mobile-nav-girls'
                  : 'mobile-nav'
        this.querySelector(`.mobile-nav__type-selector input[value="${inputValue}"]`).click()
      }
      const tab = urlParams.get('featured_category')
      if (tab) {
        this.querySelector(`.grid-nav-v2__button input[value="${this.handleize(tab)}"]`).click()
      }
      if (tab || dep) {
        const headerWrapper = document.querySelector('main-nav')
        const yOffset = headerWrapper !== null ? (headerWrapper.offsetHeight + 20) * -1 : 0
        const yCoordinate = this.getBoundingClientRect().top + window.pageYOffset
        window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' })
      }
    }

    async fetchMenu() {
      this.abortController?.abort()
      this.abortController = new AbortController()

      this.classList.add('loading')
      this.menuHandle = this.getAttribute('data-menu-handle')
      const query = `
          query MobileNav @inContext(country: ${this.dataset.country.toUpperCase()}, language: ${this.dataset.locale.toUpperCase()}) {
            metaobject(handle: {handle: "${this.menuHandle}", type: "menu"}) {
              titleField: field(key: "title") {
                value
              }
              tabTextField: field(key: "tab_text") {
                value
              }
              bannerField: field(key: "banner") {
                reference {
                  ... on MediaImage {
                    alt
                    image {
                      url
                    }
                  }
                }
              }
              bannerUrlField: field(key: "banner_link") {
                value
              }
              featureCategoryField: field(key: "featured_category") {
                reference {
                  ... on Metaobject {
                    nameField: field(key: "category_name") {
                      value
                    }
                    urlField: field(key: "url") {
                      value
                    }
                    categoryImageField: field(key: "featured_image") {
                      reference {
                        ... on MediaImage {
                          image {
                            url
                          }
                        }
                      }
                    }
                    itemsField: field(key: "menu_items") {
                      references(first: 100) {
                        edges {
                          node {
                            ... on Metaobject {
                              titleField: field(key: "title") {
                                value
                              }
                              imageField: field(key: "image_desktop") {
                                reference {
                                  ... on MediaImage {
                                    image {
                                      url
                                    }
                                  }
                                }
                              }
                              imageForTestingField: field(key: "image_for_testing") {
                                reference {
                                  ... on MediaImage {
                                    image {
                                      url
                                    }
                                  }
                                }
                              }
                              productField: field(key: "product") {
                                reference {
                                  ... on Product {
                                    title
                                    availableForSale
                                    onlineStoreUrl
                                  }
                                }
                              }
                              collectionField: field(key: "collection") {
                                reference {
                                  ... on Collection {
                                    onlineStoreUrl
                                    firstAvailableProduct: products(first: 1, filters: { available: true }) {
                                      edges {
                                        node {
                                          onlineStoreUrl
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                              useCollectionUrlField: field(key: "use_collection_url") {
                                value
                              }
                              showNewArrivalBadgeField: field(key: "show_new_arrival_badge") {
                                value
                              }
                              showNewArrivalBadgeDateField: field(key: "new_arrival_badge_end_date") {
                                value
                              }
                              clearanceItemField: field(key: "clearance_item") {
                                references(first: 100) {
                                  edges {
                                    node {
                                      ... on Product {
                                        onlineStoreUrl
                                        featuredImage {
                                          url
                                        }
                                        priceRange {
                                          minVariantPrice {
                                            amount
                                          }
                                          maxVariantPrice {
                                            amount
                                          }
                                        }
                                        compareAtPriceRange {
                                          minVariantPrice {
                                            amount
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
              categoriesField: field(key: "categories") {
                references(first: 100) {
                  edges {
                    node {
                      ... on Metaobject {
                        nameField: field(key: "category_name") {
                          value
                        }
                        urlField: field(key: "url") {
                          value
                        }
                        categoryImageField: field(key: "featured_image") {
                          reference {
                            ... on MediaImage {
                              image {
                                url
                              }
                            }
                          }
                        }
                        itemsField: field(key: "menu_items") {
                          references(first: 100) {
                            edges {
                              node {
                                ... on Metaobject {
                                  titleField: field(key: "title") {
                                    value
                                  }
                                  imageField: field(key: "image_desktop") {
                                    reference {
                                      ... on MediaImage {
                                        image {
                                          url
                                        }
                                      }
                                    }
                                  }
                                  imageForTestingField: field(key: "image_for_testing") {
                                    reference {
                                      ... on MediaImage {
                                        image {
                                          url
                                        }
                                      }
                                    }
                                  }
                                  productField: field(key: "product") {
                                    reference {
                                      ... on Product {
                                        title
                                        availableForSale
                                        onlineStoreUrl
                                      }
                                    }
                                  }
                                  collectionField: field(key: "collection") {
                                    reference {
                                      ... on Collection {
                                        onlineStoreUrl
                                        firstAvailableProduct: products(first: 1, filters: { available: true }) {
                                          edges {
                                            node {
                                              onlineStoreUrl
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                  useCollectionUrlField: field(key: "use_collection_url") {
                                    value
                                  }
                                  showNewArrivalBadgeField: field(key: "show_new_arrival_badge") {
                                    value
                                  }
                                  showNewArrivalBadgeDateField: field(key: "new_arrival_badge_end_date") {
                                    value
                                  }
                                  clearanceItemField: field(key: "clearance_item") {
                                    references(first: 100) {
                                      edges {
                                        node {
                                          ... on Product {
                                            onlineStoreUrl
                                            featuredImage {
                                              url
                                            }
                                            priceRange {
                                              minVariantPrice {
                                                amount
                                              }
                                              maxVariantPrice {
                                                amount
                                              }
                                            }
                                            compareAtPriceRange {
                                              minVariantPrice {
                                                amount
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        `

      const endpoint = '/api/2025-07/graphql.json'

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': 'b7cddfa2ac815edc1ce3062ba667fe38',
          },
          body: JSON.stringify({ query }),
          signal: this.abortController.signal,
        })

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const data = await response.json()

        if (data.errors) {
          console.error('GraphQL errors:', data.errors)
        } else {
          const transformedData = this.transformMenuData(data.data.metaobject)
          this.renderContent(transformedData)
          this.classList.remove('loading')
        }
      } catch (error) {
        if (error.name === 'AbortError') {
          this.classList.remove('loading')
        } else {
          console.log('Error:', error)
        }
      }
    }

    transformMenuData(menuData) {
      // Transform banner
      const banner = menuData.bannerField?.reference?.image?.url || null
      const bannerUrl = menuData.bannerUrlField?.value || null

      // Transform featured category
      const featuredCategory = menuData.featureCategoryField?.reference
        ? {
            name: menuData.featureCategoryField.reference.nameField.value,
            url: menuData.featureCategoryField.reference.urlField?.value || null,
            image:
              menuData.featureCategoryField.reference.categoryImageField?.reference?.image?.url ||
              null,
            items:
              menuData.featureCategoryField.reference.itemsField?.references?.edges
                ?.map(({ node }) => {
                  // console.log('node', node.clearanceItemField?.references?.edges?.[0]?.node?.featuredImage?.url)
                  const clearanceProduct = node.clearanceItemField?.references?.edges?.[0]?.node
                  const price = clearanceProduct?.priceRange?.minVariantPrice?.amount
                    ? parseFloat(clearanceProduct.priceRange.minVariantPrice.amount)
                    : null
                  const compareAtPrice = clearanceProduct?.compareAtPriceRange?.minVariantPrice
                    ?.amount
                    ? parseFloat(clearanceProduct.compareAtPriceRange.minVariantPrice.amount)
                    : null
                  const discountPercentage =
                    price && compareAtPrice && compareAtPrice > price
                      ? Math.round(((compareAtPrice - price) / compareAtPrice) * 100)
                      : null
                  // console.log('discountPercentage', discountPercentage)
                  return {
                    title: node.titleField?.value || null,
                    image: node.imageField?.reference?.image?.url || null,
                    clearanceImage:
                      node.clearanceItemField?.references?.edges?.[0]?.node?.featuredImage?.url ||
                      null,
                    image_for_testing:
                      node.imageForTestingField?.reference?.image?.url ||
                      node.imageField?.reference?.image?.url ||
                      null,
                    productUrl: node.productField?.reference?.availableForSale
                      ? node.productField?.reference?.onlineStoreUrl
                      : null,
                    firstAvailableProductUrl:
                      node.useCollectionUrlField?.value === 'true'
                        ? node.collectionField?.reference?.onlineStoreUrl
                        : node.collectionField?.reference?.firstAvailableProduct?.edges[0]?.node
                            ?.onlineStoreUrl || null,
                    showNewArrivalBadgeField:
                      node.showNewArrivalBadgeField?.value === 'true' ? true : false,
                    showNewArrivalBadgeDateField:
                      new Date(node.showNewArrivalBadgeDateField?.value).getTime() || 0,
                    clearanceItemUrl:
                      node.clearanceItemField?.references?.edges?.[0]?.node?.onlineStoreUrl || null,
                    discountPercentage,
                  }
                })
                ?.filter((item) => item.title) || [],
          }
        : null

      // Transform regular categories
      const categories =
        menuData.categoriesField?.references?.edges?.map(({ node }) => ({
          name: node.nameField?.value || null,
          url: node.urlField?.value || null,
          image: node.categoryImageField?.reference?.image?.url || null,
          items:
            node.itemsField?.references?.edges
              ?.map(({ node }) => {
                // console.log('node', node.clearanceItemField?.references?.edges?.[0]?.node?.featuredImage?.url)
                const clearanceProduct = node.clearanceItemField?.references?.edges?.[0]?.node
                const price = clearanceProduct?.priceRange?.minVariantPrice?.amount
                  ? parseFloat(clearanceProduct.priceRange.minVariantPrice.amount)
                  : null
                const compareAtPrice = clearanceProduct?.compareAtPriceRange?.minVariantPrice
                  ?.amount
                  ? parseFloat(clearanceProduct.compareAtPriceRange.minVariantPrice.amount)
                  : null
                const discountPercentage =
                  price && compareAtPrice && compareAtPrice > price
                    ? Math.round(((compareAtPrice - price) / compareAtPrice) * 100)
                    : null
                // console.log('discountPercentage', discountPercentage)
                return {
                  title: node.titleField?.value || null,
                  image: node.imageField?.reference?.image?.url || null,
                  clearanceImage:
                    node.clearanceItemField?.references?.edges?.[0]?.node?.featuredImage?.url ||
                    null,
                  image_for_testing:
                    node.imageForTestingField?.reference?.image?.url ||
                    node.imageField?.reference?.image?.url ||
                    null,
                  productUrl: node.productField?.reference?.availableForSale
                    ? node.productField?.reference?.onlineStoreUrl
                    : null,
                  firstAvailableProductUrl:
                    node.useCollectionUrlField?.value === 'true'
                      ? node.collectionField?.reference?.onlineStoreUrl
                      : node.collectionField?.reference?.firstAvailableProduct?.edges[0]?.node
                          ?.onlineStoreUrl || null,
                  showNewArrivalBadgeField:
                    node.showNewArrivalBadgeField?.value === 'true' ? true : false,
                  showNewArrivalBadgeDateField:
                    new Date(node.showNewArrivalBadgeDateField?.value).getTime() || 0,
                  clearanceItemUrl:
                    node.clearanceItemField?.references?.edges?.[0]?.node?.onlineStoreUrl || null,
                  discountPercentage,
                }
              })
              ?.filter((item) => item.title) || [],
        })) || []

      return {
        banner,
        bannerUrl,
        featuredCategory,
        categories,
      }
    }

    handleize(string) {
      return string
        .toLowerCase()
        .replace(/ /g, '-')
        .replace(/[^\w-]+/g, '')
    }

    renderContent(transformedData) {
      if (!transformedData) return
      const isClearancePage = window && window.location.pathname.includes('clearance')

      const currentTimestamp = Date.now()
      let html = ''
      let navItemsArray = []
      let contentTiles = ''
      if (transformedData.featuredCategory) {
        const { name, url, image, items } = transformedData.featuredCategory
        let itemContentTiles = ''

        items.forEach((item) => {
          let renderItem = true
          const clearanceItemUrl = item.clearanceItemUrl || null

          if (isClearancePage && clearanceItemUrl === null) {
            renderItem = false
          } else if (
            !isClearancePage &&
            item.productUrl === null &&
            item.firstAvailableProductUrl === null
          ) {
            renderItem = false
          }

          if (renderItem) {
            itemContentTiles += `
                <li class="grid-nav-v2__item ${isClearancePage ? 'grid-nav-v2__item--clearance' : ''}" data-grid-category="${this.handleize(name)}" data-grid-style="${this.handleize(item.title)}">
                  <a href="${isClearancePage ? clearanceItemUrl : item.productUrl || item.firstAvailableProductUrl || '#'}">
                    <div class="grid-nav-v2__image">
                      <img class="nav-menu-image-for-testing_a" src="${isClearancePage ? item.clearanceImage : item.image}&width=400" loading="lazy" alt="" width="232" height="298">
                      <img class="nav-menu-image-for-testing_b" src="${isClearancePage ? item.clearanceImage : item.image_for_testing}&width=400" loading="lazy" alt="" width="232" height="298" style="display: none;">
                      ${isClearancePage && item.discountPercentage ? `<div class="grid-nav-v2__discount-badge">Up to ${item.discountPercentage}% OFF</div>` : ''}
                    </div>
                    <h3 class="grid-nav-v2__title">
                      <span>${item.title}</span>
                    </h3>
                  </a>
                  ${
                    item.showNewArrivalBadgeField &&
                    item.showNewArrivalBadgeDateField > currentTimestamp
                      ? `<div class="rebuilt-product-card__badge top-left">
                    <span>New</span>
                  </div>`
                      : ''
                  }
                </li>
              `
          }
        })

        if (itemContentTiles !== '') {
          navItemsArray.push(`
              <label class="grid-nav-v2__button button ${isClearancePage ? 'grid-nav-v2__button--clearance' : ''}" data-grid-cat="${this.handleize(name)}">
                <input class="visually-hidden js-grid-nav-v2-tab" type="radio" name="grid-nav-v2-tab-${this.sectionId}" value="${this.handleize(name)}" checked autocomplete="off">
                ${isClearancePage && image ? `<div class="grid-nav-v2__button--clearance-image-wrapper"><img src="${image}" loading="eager" alt="${name}" width="100" height="100"></div>` : ''}
                <span>${name}</span>
              </label>
            `)
          contentTiles += itemContentTiles
        }
      }
      if (transformedData.categories) {
        transformedData.categories.forEach((category, index) => {
          const { name, url, image, items } = category
          let itemContentTiles = ''

          items.forEach((item) => {
            let renderItem = true
            const clearanceItemUrl = item.clearanceItemUrl || null

            if (isClearancePage && clearanceItemUrl === null) {
              renderItem = false
            } else if (
              !isClearancePage &&
              item.productUrl === null &&
              item.firstAvailableProductUrl === null
            ) {
              renderItem = false
            }

            if (renderItem) {
              itemContentTiles += `
                  <li class="grid-nav-v2__item ${isClearancePage ? 'grid-nav-v2__item--clearance' : ''} ${transformedData.featuredCategory ? 'visually-hidden' : index === 0 ? '' : 'visually-hidden'}" data-grid-category="${this.handleize(name)}" data-grid-style="${this.handleize(item.title)}">
                    <a href="${isClearancePage ? clearanceItemUrl : item.productUrl || item.firstAvailableProductUrl || '#'}">
                      <div class="grid-nav-v2__image">
                        <img class="nav-menu-image-for-testing_a" src="${isClearancePage ? item.clearanceImage : item.image}&width=400" loading="lazy" alt="" width="232" height="298">
                        <img class="nav-menu-image-for-testing_b" src="${isClearancePage ? item.clearanceImage : item.image_for_testing}&width=400" loading="lazy" alt="" width="232" height="298" style="display: none;">
                        ${isClearancePage && item.discountPercentage ? `<div class="grid-nav-v2__discount-badge">Up to ${item.discountPercentage}% OFF</div>` : ''}
                      </div>
                      <h3 class="grid-nav-v2__title">
                        <span>${item.title}</span>
                      </h3>
                    </a>
                    ${
                      item.showNewArrivalBadgeField &&
                      item.showNewArrivalBadgeDateField > currentTimestamp
                        ? `<div class="rebuilt-product-card__badge top-left">
                      <span>New</span>
                    </div>`
                        : ''
                    }
                  </li>
                `
            }
          })

          if (itemContentTiles !== '') {
            navItemsArray.push(`
                <label class="grid-nav-v2__button button ${isClearancePage ? 'grid-nav-v2__button--clearance' : ''}" data-grid-cat="${this.handleize(name)}">
                  <input class="visually-hidden js-grid-nav-v2-tab" type="radio" name="grid-nav-v2-tab-${this.sectionId}" value="${this.handleize(name)}" ${transformedData.featuredCategory ? '' : index === 0 ? 'checked' : ''} autocomplete="off">
                  ${isClearancePage && image ? `<div class="grid-nav-v2__button--clearance-image-wrapper"><img src="${image}" loading="eager" alt="${name}" width="100" height="100"></div>` : ''}
                  <span>${name}</span>
                </label>
              `)
            contentTiles += itemContentTiles
          }
        })
      }

      let navItems = ''
      if (isClearancePage) {
        for (let i = 0; i < navItemsArray.length; i += 2) {
          const pair = navItemsArray.slice(i, i + 2).join('')
          navItems += `<div class="grid-nav-v2__nav--clearance-button-pair">${pair}</div>`
        }
      } else {
        navItems = navItemsArray.join('')
      }

      html += `<div class="grid-nav-v2__nav ${isClearancePage ? 'grid-nav-v2__nav--clearance' : ''} ${transformedData.categories.length === 0 ? 'visually-hidden' : ''}">${navItems}</div>`
      html += `<ul class="grid-nav-v2__grid">${contentTiles}</ul>`

      this.content.innerHTML = html
    }

    tabChangeHandle(e) {
      if (!e.target.classList.contains('js-grid-nav-v2-tab')) return
      this.switchTab(e.target.value)
    }

    switchTab(tabHandle) {
      this.querySelectorAll('.grid-nav-v2__item').forEach((item) => {
        item.classList.add('visually-hidden')
      })
      this.querySelectorAll(`.grid-nav-v2__item[data-grid-category=${tabHandle}]`).forEach(
        (item) => {
          item.classList.remove('visually-hidden')
        },
      )
    }
  }
  customElements.define('grid-nav', GridNav)
}
